import PageMeta from './PageMeta';

/** Injects noindex,nofollow for transactional SPA routes that should not rank. */
export default function NoIndexMeta() {
  return <PageMeta noIndex />;
}
